export default {
  CLOSE: 'close',
  SHOW_ADD: 'showAdd',
  SHOW_EDIT: 'showEdit',
  SHOW_LIST: 'showList',
  SWITCH_PROFILE: 'switchProfile',
};
